// ScrollToTopButton — iter76 floating circle that appears after scrolling
// 200px down and fades out within 200px of the top. Smooth-scrolls to top
// on tap. Visible globally on every scrollable page.
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const APPEAR_AT = 200;
const NEAR_BOTTOM = 120; // hide when within 120px of page bottom so we don't cover the footer text

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      const doc = document.documentElement;
      const distanceFromBottom = (doc.scrollHeight - window.innerHeight) - y;
      setVisible(y > APPEAR_AT && distanceFromBottom > NEAR_BOTTOM);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onClick = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }
  };

  return (
    <button
      type="button"
      data-testid="scroll-to-top-fab"
      onClick={onClick}
      aria-label="Scroll to top"
      style={{
        position: "fixed",
        right: 16,
        bottom: 96, // sits above the 64px bottom-nav + 16px gap
        width: 40,
        height: 40,
        borderRadius: 999,
        background: "#E8B84B",
        color: "#0B0B0B",
        border: "none",
        display: "grid",
        placeItems: "center",
        boxShadow: "0 8px 24px rgba(0,0,0,0.45)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(10px)",
        transition: "opacity 240ms ease, transform 240ms ease",
        zIndex: 45,
      }}
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2} />
    </button>
  );
}
